import { render, staticRenderFns } from "./ot-publisher.vue?vue&type=template&id=3b2e9ebd"
import script from "./ot-publisher.vue?vue&type=script&lang=js"
export * from "./ot-publisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports